import { useState } from 'react';

const faqs = [
  {
    q: '可乐漫画需要付费吗？',
    a: '不需要！可乐漫画所有漫画资源完全免费，无需注册、无需充值，点开即看。我们致力于为广大漫画爱好者提供零门槛的在线阅读体验。',
  },
  {
    q: '漫画多久更新一次？',
    a: '我们会在漫画官方更新后的第一时间同步更新，热门漫画通常每周更新1-2话。您可以关注我们的更新日历，不错过任何精彩内容。',
  },
  {
    q: '支持什么设备阅读？',
    a: '可乐漫画完美支持PC端、平板和手机阅读。我们的响应式设计确保在各种屏幕尺寸下都能获得最佳的阅读体验，下拉式阅读让您畅享流畅的看漫之旅。',
  },
  {
    q: '如何找到想看的漫画？',
    a: '您可以通过顶部分类导航浏览韩漫、日漫、国漫，也可以使用热门推荐和最近更新列表发现精彩作品。我们正在开发搜索功能，敬请期待！',
  },
  {
    q: '漫画画质如何？',
    a: '我们提供高清漫画画质，所有漫画图片经过优化处理，在保证清晰度的同时兼顾加载速度，让您享受流畅的阅读体验。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h3 className="text-xl md:text-2xl font-heading text-foreground-900">常见问题</h3>
          <p className="text-sm text-foreground-500 mt-1">关于可乐漫画，你想知道的都在这里</p>
        </div>
        <div className="max-w-2xl mx-auto">
          {faqs.map((faq, i) => (
            <div key={i} className="border-b border-background-200 last:border-0">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}